import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ty-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'avsa-frontoffice';

  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.addCustomIcons();
  }

  addCustomIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'stops',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon_stops.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'notace',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon_notace.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'favorites',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon_favorites.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'lines',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon_lines.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'fares',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/icon_fares.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'luc-cuenca-arrow-right',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/luc-cuenca-arrow-right.svg')
    );
  }
}
